import { z } from 'zod';

import { CatalystsSchema } from './catalyst.schema';
import { AnalystConsensusSchema } from './consensus.schema';
import { TickerSchema } from './primitives';
import { SecuritySchema } from './security.schema';
import { SeriesStatsSchema } from './series.schema';

/**
 * Stock-screen profile for GET /v1/securities/:ticker (plan §6.6):
 * security row + 52w range stats + F15 consensus|null + catalysts[] +
 * optional alias affordance fields on former-alias 200s.
 */
export const SecurityProfileSchema = z.object({
  security: SecuritySchema,
  /** 52-week range and series extrema (F12/F13). */
  stats: SeriesStatsSchema,
  /** Live v1: null; synthetic: seeded AnalystConsensus. */
  consensus: AnalystConsensusSchema.nullable(),
  /** Live v1: []; synthetic: four seeded headlines. */
  catalysts: CatalystsSchema,
  /** Normalized requested path alias when it differs from the open ticker. */
  requestedTicker: TickerSchema.optional(),
  /** Canonical active ticker when the request used a former alias. */
  canonicalTicker: TickerSchema.optional(),
});
export type SecurityProfile = z.infer<typeof SecurityProfileSchema>;
